import { useInstallerContext } from '../context/InstallerContext';
import { browserNavigation } from '../utils/navigation';
export const useNavigate = () => {
  const {
    overrideNavigate
  } = useInstallerContext();
  if (overrideNavigate != null && overrideNavigate.overrideFunc) {
    return overrideNavigate.overrideFunc;
  } else {
    return (_ref, isNewWindowOpened, updateWindowSrcWithUrl, avoidPostInstallInNewWindow) => {
      let {
        link
      } = _ref;
      if (!link) {
        avoidPostInstallInNewWindow();
        return;
      }
      if (isNewWindowOpened) {
        updateWindowSrcWithUrl(link);
      } else {
        browserNavigation(link);
      }
    };
  }
};
//# sourceMappingURL=useNavigate.js.map